import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import { equal } from '@ember/object/computed';
import LayoutController from 'cio/controllers/layout';
import afterRender from 'cio/utils/after-render';

export default class EditController extends LayoutController {
  @service auth;
  resetting = false;
  currentTab = 'edit';

  get canEdit() {
    return this.auth.hasPermission('journeys/layouts/edit');
  }

  get canDelete() {
    return this.auth.hasPermission('journeys/layouts/delete');
  }

  get tabs() {
    if (!this.canEdit) {
      return [
        { label: 'Code', value: 'edit' },
        { label: 'Preview', value: 'preview' },
      ];
    } else {
      return [
        { label: 'Edit', value: 'edit' },
        { label: 'Preview', value: 'preview' },
      ];
    }
  }

  get hasUsage() {
    return this.model.emailsCount > 0;
  }

  @computed('model.hasDirtyAttributes')
  get isDirty() {
    return this.model.hasDirtyAttributes;
  }

  @equal('currentTab', 'edit') editVisible;

  @equal('currentTab', 'preview') previewVisible;

  @action
  saveLayout() {
    return this.model.save();
  }

  @action
  resetLayout() {
    this.model.rollbackAttributes();

    // Remove and replace the Ace editor component
    this.set('resetting', true);

    afterRender(() => this.set('resetting', false));
  }

  @action
  deleteLayout() {
    return this._deleteLayout();
  }
}
